import {JsonProperty} from 'json-typescript-mapper';
import {MarketDateComment} from './market-date-comment.model';
import {Contact, ContactSimplified} from './contact.model';
import {MarketdateStatus} from './marketdate-status.model';

export enum MarketOperation {
  Cancelled = <any>'Cancelled',
  TakesPlace = <any>'TakesPlace',
  Before = <any>'Before',
  After = <any>'After'
};

export class MarketdateBoothStatistics {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('boothCount')
  public boothCount?: number;

  @JsonProperty('completedBooths')
  public completedBooths?: number;

  @JsonProperty('soldSqm')
  public soldSqm?: number;

  @JsonProperty('occupiedSqm')
  public occupiedSqm?: number;

  constructor() {
    this.id = void 0;
    this.boothCount = void 0;
    this.completedBooths = void 0;
    this.soldSqm = void 0;
    this.occupiedSqm = void 0;
  }
}

export class MarketOverviewViewEntry {

  @JsonProperty('marketdateId')
  public marketdateId?: string;

  @JsonProperty('closedAt')
  public closedAt?: string;

  @JsonProperty('closedBy')
  public closedBy?: string;

  @JsonProperty('closedByContact')
  public closedByContact?: ContactSimplified;

  @JsonProperty('deferred')
  public deferred?: boolean;

  @JsonProperty('evasiveDate')
  public evasiveDate?: string;

  @JsonProperty({clazz: MarketDateComment, name: 'marketDateComments'})
  public marketDateComments?: MarketDateComment[];

  @JsonProperty('marketTitle')
  public marketTitle?: string;

  @JsonProperty('openedAt')
  public openedAt?: string;

  @JsonProperty('openedBy')
  public openedBy?: string;

  @JsonProperty('openedByContact')
  public openedByContact?: ContactSimplified;

  @JsonProperty('originalDate')
  public originalDate?: string;

  @JsonProperty('status')
  public status?: string;

  @JsonProperty('marketdateStatuses')
  public marketdateStatuses?: MarketdateStatus[];

  @JsonProperty('total')
  public total?: number;

  @JsonProperty('payment')
  public payment?: number;

  @JsonProperty('marketMasters')
  public marketMasters?: ContactSimplified[];

  @JsonProperty('modifiedBy')
  public modifiedBy?: string;

  @JsonProperty('modifiedByNumber')
  public modifiedByNumber?: string;

  @JsonProperty('updatedAt')
  public updatedAt?: number;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: string;

  @JsonProperty('branch')
  public branch?: string;

  @JsonProperty('federalState')
  public federalState?: string;

  @JsonProperty('holiday')
  public holiday?: boolean;

  @JsonProperty('canceled')
  public canceled?: boolean;

  @JsonProperty('comment')
  public comment?: string;

  @JsonProperty('onHoliday')
  public onHoliday?: MarketOperation;

  @JsonProperty('transferred')
  public transferred?: boolean;

  @JsonProperty('transferredAt')
  public transferredAt?: string;

  @JsonProperty('openPayments')
  public openPayments?: number;

  @JsonProperty('mm1Id')
  public mm1Id?: number;

  @JsonProperty('mm1UserId')
  public mm1UserId?: number;

  @JsonProperty('mm1DisplayName')
  public mm1DisplayName?: string;

  @JsonProperty('mm1Phone')
  public mm1Phone?: string;

  @JsonProperty('mm1Mobile')
  public mm1Mobile?: string;

  @JsonProperty('mm1Number')
  public mm1Number?: string;

  @JsonProperty('mm1Activated')
  public mm1Activated?: boolean;

  @JsonProperty('mm2Id')
  public mm2Id?: number;

  @JsonProperty('mm2UserId')
  public mm2UserId?: number;

  @JsonProperty('mm2DisplayName')
  public mm2DisplayName?: string;

  @JsonProperty('mm2Phone')
  public mm2Phone?: string;

  @JsonProperty('mm2Mobile')
  public mm2Mobile?: string;

  @JsonProperty('mm2Number')
  public mm2Number?: string;

  @JsonProperty('mm2Activated')
  public mm2Activated?: boolean;

  @JsonProperty('mm3Id')
  public mm3Id?: number;

  @JsonProperty('mm3UserId')
  public mm3UserId?: number;

  @JsonProperty('mm3DisplayName')
  public mm3DisplayName?: string;

  @JsonProperty('mm3Phone')
  public mm3Phone?: string;

  @JsonProperty('mm3Mobile')
  public mm3Mobile?: string;

  @JsonProperty('mm3Number')
  public mm3Number?: string;

  @JsonProperty('mm3Activated')
  public mm3Activated?: boolean;

  @JsonProperty('interim1Id')
  public interim1Id?: number;

  @JsonProperty('interim1UserId')
  public interim1UserId?: number;

  @JsonProperty('interim1DisplayName')
  public interim1DisplayName?: string;

  @JsonProperty('interim1Phone')
  public interim1Phone?: string;

  @JsonProperty('interim1Mobile')
  public interim1Mobile?: string;

  @JsonProperty('interim1Number')
  public interim1Number?: string;

  @JsonProperty('interim1Activated')
  public interim1Activated?: boolean;

  @JsonProperty('interim2Id')
  public interim2Id?: number;

  @JsonProperty('interim2UserId')
  public interim2UserId?: number;

  @JsonProperty('interim2DisplayName')
  public interim2DisplayName?: string;

  @JsonProperty('interim2Phone')
  public interim2Phone?: string;

  @JsonProperty('interim2Mobile')
  public interim2Mobile?: string;

  @JsonProperty('interim2Number')
  public interim2Number?: string;

  @JsonProperty('interim2Activated')
  public interim2Activated?: boolean;

  @JsonProperty('interim3Id')
  public interim3Id?: number;

  @JsonProperty('interim3UserId')
  public interim3UserId?: number;

  @JsonProperty('interim3DisplayName')
  public interim3DisplayName?: string;

  @JsonProperty('interim3Phone')
  public interim3Phone?: string;

  @JsonProperty('interim3Mobile')
  public interim3Mobile?: string;

  @JsonProperty('interim3Number')
  public interim3Number?: string;

  @JsonProperty('interim3Activated')
  public interim3Activated?: boolean;

  @JsonProperty('soldSqm')
  public soldSqm?: number;

  @JsonProperty('closedByNumber')
  public closedByNumber?: string;

  @JsonProperty('discounts')
  public discounts?: number;

  @JsonProperty('negativeAnswers')
  public negativeAnswers?: number;

  @JsonProperty('mm1Status')
  public mm1Status?: string;

  @JsonProperty('mm2Status')
  public mm2Status?: string;

  @JsonProperty('mm3Status')
  public mm3Status?: string;

  constructor() {
    this.marketdateId = void 0;
    this.closedAt = void 0;
    this.closedBy = void 0;
    this.closedByContact = void 0;
    this.deferred = void 0;
    this.evasiveDate = void 0;
    this.marketDateComments = void 0;
    this.marketTitle = void 0;
    this.openedAt = void 0;
    this.openedBy = void 0;
    this.openedByContact = void 0;
    this.originalDate = void 0;
    this.status = void 0;
    this.marketdateStatuses = void 0;
    this.total = void 0;
    this.payment = void 0;
    this.marketMasters = void 0;
    this.modifiedBy = void 0;
    this.modifiedByNumber = void 0;
    this.updatedAt = void 0;
    this.marketdayNumber = void 0;
    this.branch = void 0;
    this.federalState = void 0;
    this.holiday = void 0;
    this.canceled = void 0;
    this.comment = void 0;
    this.onHoliday = void 0;
    this.transferred = void 0;
    this.transferredAt = void 0;
    this.openPayments = void 0;
    this.soldSqm = void 0;
    this.mm1Id = void 0;
    this.mm1UserId = void 0;
    this.mm1Number = void 0;
    this.mm1Mobile = void 0;
    this.mm1DisplayName = void 0;
    this.mm1Phone = void 0;
    this.mm2Id = void 0;
    this.mm2UserId = void 0;
    this.mm2Number = void 0;
    this.mm2Mobile = void 0;
    this.mm2DisplayName = void 0;
    this.mm2Phone = void 0;
    this.mm3Id = void 0;
    this.mm3UserId = void 0;
    this.mm3Number = void 0;
    this.mm3Mobile = void 0;
    this.mm3DisplayName = void 0;
    this.mm3Phone = void 0;
    this.interim1Id = void 0;
    this.interim1Number = void 0;
    this.interim1Mobile = void 0;
    this.interim1DisplayName = void 0;
    this.interim1Phone = void 0;
    this.interim2Id = void 0;
    this.interim2Number = void 0;
    this.interim2Mobile = void 0;
    this.interim2DisplayName = void 0;
    this.interim2Phone = void 0;
    this.interim3Id = void 0;
    this.interim3Number = void 0;
    this.interim3Mobile = void 0;
    this.interim3DisplayName = void 0;
    this.interim3Phone = void 0;
    this.interim1Activated = void 0;
    this.interim2Activated = void 0;
    this.interim3Activated = void 0;
    this.mm1Activated = void 0;
    this.mm2Activated = void 0;
    this.mm3Activated = void 0;
    this.closedByNumber = void 0;
    this.discounts = void 0;
    this.negativeAnswers = void 0;
    this.interim1UserId = void 0;
    this.interim2UserId = void 0;
    this.interim3UserId = void 0;
    this.mm1Status = void 0;
    this.mm2Status = void 0;
    this.mm3Status = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/market-overview-view-entry.model.ts